import React from 'react';
import Select, { components } from 'react-select';
import '../Filters/Filters.scss';

const MultiSelectFilter = ({
  label,
  options,
  value,
  onChange,
  placeholder = 'Select',
  countLabel = 'Repository'
}) => {
  const [menuIsOpen, setMenuIsOpen] = React.useState(false);
  const selectRef = React.useRef(null);

  const MultiValue = (props) => {
    return null;
  };

  const ValueContainer = (props) => {
    const { children, getValue } = props;
    const selected = getValue();
    const count = selected.length;

    return (
      <components.ValueContainer {...props}>
        <div className="filter-select-value-container-has-value">
          {children}
          {count > 0 && (
            <div>
              {count} {count === 1 ? countLabel : `${countLabel}s`} selected
            </div>
          )}
        </div>
      </components.ValueContainer>
    );
  };

  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div className="filter-select-option-checkbox">
          <input
            type="checkbox"
            checked={props.isSelected}
            readOnly
          />
          {props.label}
        </div>
      </components.Option>
    );
  };

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setMenuIsOpen(false);
      }
    };

    if (menuIsOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuIsOpen]);

  return (
    <div className="filter-control" ref={selectRef}>
      {label && <label className="filter-label">{label}</label>}

      <Select
        className='custom-select'
        classNamePrefix="filter-select"
        options={options}
        value={value}
        onChange={onChange}
        isMulti
        placeholder={placeholder}
        components={{
          Option,
          MultiValue,
          ValueContainer,
        }}
        hideSelectedOptions={false}  // keep selected in list
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)} // Prevent react-select from closing the menu
        closeMenuOnSelect={false}    // allow multiple select
      />
    </div>
  );
};

export default MultiSelectFilter;
